import { Inject, Injectable } from '@angular/core';
import { RecentScreensService } from './RecentScreensService/recent-screens.service';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { HttpService } from './HttpClientServices/Http.service';
import { UserInfo } from 'src/app/userInfo';
import { IScreen } from 'BI-Libraries/BI-Interfaces/dist/bi-interfaces';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class FavoriteScreensService {

  private maxFavoritePages = 10;

  private favoritePagesSubject = new BehaviorSubject<IScreen[]>([]);
  public favoritePages$ = this.favoritePagesSubject.asObservable();


  private addedFavoritePageSubject = new BehaviorSubject<IScreen>(null);
  public addedFavoritePage$ = this.addedFavoritePageSubject.asObservable();

  private deletedFavoritePageSubject = new BehaviorSubject<string>('');
  public deletedFavoritePage$ = this.deletedFavoritePageSubject.asObservable();



  private localStorageKey = 'favoritePages';
  public currentUrl = '';
  constructor(
    @Inject('UIUserProfile') public uiProfileService,
    private httpService: HttpService,
    private translateService: TranslateService

  ) {
    this.favoritePagesSubject.next(this.getLocalFavoritePagesFlattenedList());
   }

   //#region GENERAL HANDLE BOTH LOCAL AND LOCAL FUNCTIONS
   public getFavoritePages(): Observable<IScreen[]>{
    const pages: IScreen[] =this.getLocalFavoritePagesFlattenedList()
    if(pages && pages.length > 0){
      return of(pages);
    }else{
      return this.getDBFavoritePages()
    }
   }



   //#endregion

   //#region BACKEND FUNCTIONS
  public getDBFavoritePages():Observable<IScreen[]> | null{
    return this.httpService.get(`BS_FavoriteScreen?$filter=UserName eq '${UserInfo.UserName}'`)
    .pipe(
      map((response: any) => {
        if (response && response.value) {
          return response.value.map((item: any) => ({
            Id: item.Id,
            PageName: item.ScreenName,
            PageUrl: item.ScreenUrl
          }));
        }
        return of(null);
      }),
      catchError(error => {
        console.error('An error occurred:', error);
        return of(null);
      })
    )
  }

  public saveDBPageAsFavorite(pageUrl: string): Observable<any>{
    this.checkIfExceedsMaxFavorites();
    return this.httpService.add(`BS_FavoriteScreen`,{
      UserName: UserInfo.UserName,
      ScreenUrl: pageUrl,
      ScreenName: ''
    })
  }

  public deleteDBPageFromFavorite(screenDBID: string): Observable<any>{
    return this.httpService.delete(
      `BS_FavoriteScreen/${screenDBID}`
    )
  }

   //#endregion 

   //#region  LOCAL FUNCTIONS
  public saveLocalPageAsFavorite(url: string, id: string, pageName: string){
    this.checkIfExceedsMaxFavorites();
    const pages = this.getLocalFavoritePages();
    pages.set(url,{PageName: pageName, PageUrl: url, Id: id.toString()});
    this.savePagesLocal(pages);
    this.addedFavoritePageSubject.next({Id: id, PageName: pageName, PageUrl: url});
  }
  public getLocalFavoritePages(): Map<string, IScreen>{
    const storedValue = localStorage.getItem(this.localStorageKey);
    const parsed = storedValue ? JSON.parse(storedValue) : [];
    if(Array.isArray(parsed))
      return new Map<string, IScreen>(parsed);
    return new Map<string, IScreen>();
  }
  public getLocalFavoritePagesFlattenedList(): IScreen[] {
    const pages = this.getLocalFavoritePages();
    return Array.from(pages.values());
  }
  public deleteLocalFavoritePage(url: string){
    const pages = this.getLocalFavoritePages();
    if(pages.has(url))
      pages.delete(url);
    this.savePagesLocal(pages);
    this.deletedFavoritePageSubject.next(url);
  }


  public savePagesLocal(pages: Map<string, IScreen>): void {
    const arrayRepresentation = Array.from(pages.entries());
    localStorage.setItem(this.localStorageKey, JSON.stringify(arrayRepresentation));
  }

  //#endregion

  private checkIfExceedsMaxFavorites(){
    const currentNumber = this.getLocalFavoritePagesFlattenedList().length;
    if (currentNumber >= this.maxFavoritePages)
      throw new Error(`${this.translateService.instant("favoritePagesCanNotBeMoreThan")} ${this.maxFavoritePages}`)
  }
}
